import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the tableBalanceHistorysView.
 * @extends JetView
 */
export default class tableBalanceHistorysView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        /**
         * Marks old values based on specified conditions.
         * @param {number} value - The value to check.
         * @param {Object} config - The configuration object.
         * @returns {Object} CSS styles for the background.
         */
        function mark_old(value, config) {
            var num = webix.Number.parse(value, {
                decimalSize: 2,
                groupSize: 3,
                decimalDelimiter: '.',
                groupDelimiter: ',',
            });
            if (num > 30 && num < 99) {
                return { background: 'orange' }; // Orange background for values between 30 and 99
            }
            if (num > 100) {
                return { background: 'red' }; // Red background for values greater than 100
            }
        }

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'treetable', // Treetable component
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border', // CSS classes for styling
                            scheme: {
                                $change: function (item) {
                                    // Change event for item
                                    if (item.BalanceEnd != item.BalanceEndCalc) {
                                        item.$css = { background: '#FFAAAA' }; // Highlight item if balances do not match
                                        if (item.BalanceEnd > item.BalanceEndCalc) {
                                            item.BalanceGap = item.BalanceEnd - item.BalanceEndCalc; // Calculate balance gap
                                        } else {
                                            item.BalanceGap = item.BalanceEndCalc - item.BalanceEnd; // Calculate balance gap
                                        }
                                    }
                                },
                            },
                            columns: [
                                {
                                    id: 'Partner', // Column ID
                                    header: _('Partner'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                    template: function (obj, common) {
                                        // Template for rendering the column
                                        if (obj.$group)
                                            return (
                                                common.treetable(obj, common) +
                                                "<span class='partner " +
                                                obj.Partner +
                                                "'></span>"
                                            );
                                        return "<span class='partner " + obj.Partner + "'></span>";
                                    },
                                },
                                {
                                    id: 'CreatedLocalDate',
                                    header: _('Fecha de creación'), // Creation date header
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 120,
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date format
                                    footer: 'Total:', // Footer text
                                },
                                {
                                    id: 'Country',
                                    header: _('País'), // Country header
                                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'), // Conditional visibility based on permissions
                                    css: 'prm-filterByCountry', // CSS class for styling
                                    width: 80,
                                    sort: 'int', // Sorting type
                                    template: function (obj) {
                                        // Template for rendering the column
                                        return "<i class='flags " + obj.Country + "'></i>";
                                    },
                                },
                                {
                                    id: 'UserId',
                                    header: _('ID Usuario'), // User ID header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserName',
                                    header: _('Nombre Usuario'), // User Name header
                                    width: 150,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'BalanceInitial',
                                    header: _('Saldo Inicial'), // Initial Balance header
                                    width: 130,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                },
                                {
                                    id: 'AmountDeposits',
                                    header: _('Depósitos'), // Deposits header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountBets',
                                    header: _('Ap. Deportivas'), // Sports Bets header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountWin',
                                    header: _('Pr. Deportivas'), // Sports Wins header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountBetsCasino',
                                    header: _('Ap. Casino'), // Casino Bets header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AmountWinCasino',
                                    header: _('Pr. Casino'), // Casino Wins header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'WithdrawCreates',
                                    header: _('Retiros Creados'), // Created Withdrawals header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'WithdrawDeletes',
                                    header: _('Retiros Eliminados'), // Deleted Withdrawals header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AdjustmentE',
                                    header: _('Ajustes E'), // Adjustments E header
                                    width: 80,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'AdjustmentS',
                                    header: _('Ajustes S'), // Adjustments S header
                                    width: 80,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'Bonus',
                                    header: _('Bonos'), // Bonuses header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BonusCasino',
                                    header: _('Bonos casino'), // Casino Bonuses header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BonusVirtual',
                                    header: _('Bonos Virtuales'), // Virtual Bonuses header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BonusCasinoLive',
                                    header: _('Bonos Casino en vivo'), // Live Casino Bonuses header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BalanceEnd',
                                    header: _('Saldo Final'), // Final Balance header
                                    width: 130,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BalanceEndCalc',
                                    header: _('Saldo Final Calc.'), // Calculated Final Balance header
                                    width: 130,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BalanceGap',
                                    header: _('Calc. Desfase'), // Calculated Gap header
                                    width: 110,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    cssFormat: mark_old, // CSS formatting function
                                },
                                {
                                    id: 'WithdrawPaid',
                                    header: _('Retiros Pagados'), // Paid Withdrawals header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'WithdrawPend',
                                    header: _('Retiros Pendientes'), // Pending Withdrawals header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'BonusFreeWin',
                                    header: _('Bonos Free Ganados'), // Free Win Bonuses header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'DepositsUsersCount',
                                    header: _('Usuarios Depositantes'), // Depositing Users header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                                {
                                    id: 'DepositsCount',
                                    header: _('Cantidad Depositos'), // Deposit Count header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                    format: webix.i18n.priceFormat, // Price format
                                    exportType: 'number', // Export type
                                    footer: { content: 'summColumn' }, // Footer content
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    // Event before loading data
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    // Event after loading data
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            ready: function () {
                                // Event when the grid is ready
                                if (!this.count()) {
                                    // Check if there are no items
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Show no data message
                                            '</div>',
                                    );
                                }
                            },
                            footer: true, // Enable footer
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            url: devConfig.geturlApi() + 'es/BalanceHistory/GetBalanceHistoryMachine', // Data source URL
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        var url = grid.data.url; // Store the data URL
        var filter = ''; // Initialize filter string

        // Event handler for after data load
        grid.attachEvent('onAfterLoad', function () {
            $$('datatable').data.group({
                // Group data by Partner
                by: 'Partner',
                map: {
                    Partner: ['Partner'],
                },
            });
        });

        // Event handler for filtering balance history
        this.on(this.app, 'balanceHistory:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string

            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'Type') {
                    // Check for Type filter
                    if (object[i][1] == 0) {
                        // If Type is 0
                        grid.showColumn('UserId', { spans: true }); // Show UserId column
                        grid.showColumn('UserName', { spans: true }); // Show UserName column
                    } else {
                        grid.hideColumn('UserId', { spans: true }); // Hide UserId column
                        grid.hideColumn('UserName', { spans: true }); // Hide UserName column
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'CreatedLocalDate') {
                        // Check for CreatedLocalDate filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        if (object[i][0] == 'ModifiedLocalDate') {
                            // Check for ModifiedLocalDate filter
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add dateFrom2 to query string
                            string1 = string1 + '&dateTo2=' + date[1]; // Add dateTo2 to query string
                        } else {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check for object filters
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Check for start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Check for end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(grid); // Log the grid instance
            grid.clearAll(); // Clear existing data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter string
        });

        // Event handler for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load data with sorting
            );
        });

        // Event handler for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
